<template>
  <div :class="c()">
    <div :class="c('item', {current: true})">
      {{ currentStep }}
    </div>
    of
    <div :class="c('item')">
      {{ totalStepsText }}
    </div>
  </div>
</template>

<script>
import {cn} from '@/app/js/classname'

const c = cn('survey-steps')
export default {
  name: 'SurveySteps',
  props: {
    step: {
      type: Number,
      default: 1
    },
    totalSteps: {
      type: Number,
      default: 6
    }
  },
  computed: {
    currentStep() {
      const i = this.step + 1
      return i.toString().padStart(2, '0')
    },
    totalStepsText() {
      return this.totalSteps.toString().padStart(2, '0')
    }
  },
  methods: {
    c
  }
}
</script>

<style lang="scss">
.survey-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: #fff;
    border: 1px solid #D9B663;
    border-radius: 8px;
    color: #D9B663;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.5px;

    &_current {
      background-color: #D9B663;
      color: #FFFFFF;
    }
  }
}
</style>
